<template>
    <div class="bax-banner-wrap">
        <div class="bax-banner-title-block" >
            <div class="container" :class="[containerClass]">
                <select class="user-switcher" v-if="((this.$router.currentRoute.path === '/') || (this.$router.currentRoute.path === '/tpn')) && (Object.keys(hospitalList).length > 1)" v-model="hospitalSelected">
                    <option value="0">Change Hospital</option>
                    <option v-for="(item, key) in hospitalList" v-bind:key="key" :value="item[0]">
                        {{item[1]}}
                    </option>
                </select>
                <div class="bax-banner-title d-md-flex align-items-center">
                    <h6 class="d-flex align-items-center"><img src="@/assets/images/login-img.png" alt="Welcome">{{user.hospitalName}}</h6>
                </div>
            </div>
        </div>
        <div class="bax-banner-content d-flex align-items-end">
            <div class="container" :class="[containerClass]">
            <h1 class="d-flex align-items-center"><slot /></h1>
            <p></p>
            </div>
        </div>
    </div>
</template>

<script>

    import User from '@/core/api/auth/User.class';

    export default {
        name: 'BaxHeaderBannerSimple',
        components: {
        },
        props: {
            user: {
                required: true,
            },
            containerClass: {
                required: false,
            },
        },
        data() {
            return {
                hospitalList: [],
                hospitalSelected: 0,
            };
        },
        mounted() {
        },
        created() {
           this.hospitalList = this.user.hospitalList;
        },
        watch: {
            hospitalSelected(val) {
                User.updateHospital(val).then(() => {
                    window.location.reload();
                });
            },
        },
    };
</script>
